// extracted by mini-css-extract-plugin
module.exports = {"loggedInAvatarContainer":"LoggedInAvatar_loggedInAvatarContainer__jqbXL","initials":"LoggedInAvatar_initials__iF_o6"};